<script setup lang="ts">
defineEmits<{
  selectAccount: []
}>()
</script>

<template>
  <UButton
    color="neutral"
    variant="outline"
    icon="i-lucide-user-search"
    block
    @click="$emit('selectAccount')"
  >
    Select Account
  </UButton>
</template>
